import { Button, Modal, ModalBody, ModalContent } from "@heroui/react";
import { BadgeCheckIcon, ExternalLinkIcon } from "lucide-react";
import { formatTimestamp } from "../../utils";
import { TransactionTypeChip } from "../bridge/TransactionTypeChip";
import { TxHashLink } from "../TxHashLink";
import { TransferCard } from "./TransferCard";
import type { TransferTxSuccess } from "./transfersConfig";

export function PrivateTransfersSuccessModal({
  isOpen,
  onClose,
  transferResult,
}: {
  isOpen: boolean;
  onClose: () => void;
  transferResult: TransferTxSuccess | null;
}) {
  if (!transferResult) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      isDismissable={false}
      isKeyboardDismissDisabled={true}
      classNames={{
        base: "turnstile-modal-border rounded-3xl",
        closeButton: "text-white text-xl top-4 right-5",
        header: "pt-5 pb-3",
        body: "items-center p-6 pt-0 gap-4",
        backdrop: "turnstile-modal-backdrop",
      }}
    >
      <ModalContent>
        <ModalBody className="flex items-center gap-2 p-8">
          <BadgeCheckIcon className="size-24 stroke-1 text-green-500/90 fill-green-500/10 " />

          <p className="font-semibold text-large">Transfer completed!</p>

          <TransferCard
            tokenSymbol={transferResult.tokenSymbol}
            displayAmount={Number(transferResult.amount)}
            senderAddress={transferResult.l2AccountAddress.toString()}
            recipientAddress={transferResult.recipientAddress.toString()}
          />

          <div className="flex flex-col gap-2 w-full text-sm">
            <div className="flex items-center justify-between">
              <div className="font-semibold text-[#ADC0D0]">Transaction type</div>
              <TransactionTypeChip type={transferResult.transferMode} />
            </div>
            <div className="flex items-center justify-between">
              <div className="font-semibold text-[#ADC0D0]">Transfer method</div>
              <div className="font-semibold space-x-2">Channel creation</div>
            </div>

            <div className="flex justify-between w-full">
              <div className="font-semibold text-[#ADC0D0]">Date & time</div>
              <div className="font-semibold">{formatTimestamp(transferResult.timestamp)}</div>
            </div>

            <div className="flex justify-between w-full">
              <div className="font-semibold text-[#ADC0D0]">Transaction Hash</div>
              <div className="font-semibold">
                <TxHashLink txHash={transferResult.txHash} source="l2" />
              </div>
            </div>

            <div className="flex justify-between w-full">
              <div className="font-semibold text-[#ADC0D0]">Network fee</div>
              <div className="font-semibold">0.00005 ETH</div>
            </div>
          </div>

          <Button
            fullWidth
            variant="bordered"
            color="primary"
            size="lg"
            radius="full"
            className="text-white"
            onPress={onClose}
          >
            View on Explorer <ExternalLinkIcon className="size-4" />
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
